module.exports = __webpack_public_path__ + "img/logo-pb-carre.ff276705.png";